module.exports = require("terser-webpack-plugin");